Monitoring.Views ||= {}
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}
Monitoring.Views.Dashboards ||= {}

class Monitoring.Views.MovistarSocialContentConditionEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_social_content_condition_edit"]

  events:
    'click input[name="condition-kind"]': 'onClickConditionKind'

    'change #condition-parent-post-ids': 'onChangeParentPostIds'
    'change #condition-parent-media-ids': 'onChangeParentMediaIds'
    'change #condition-parent-tweet-ids': 'onChangeParentTweetIds'

  initialize: (@options = {}) ->
    @socialContentCondition = @options.socialContentCondition
    @availableTags     = @options.availableTags
    @availableSubtypes = @options.availableSubtypes
    @selectedKind = @getSelectedKind()

  getSelectedKind: ->
    if @has('subtypes')
      'tags-and-types'
    else
      if @has('parent_post_ids') || @has('parent_tweet_ids') || @has('parent_media_ids')
        'tags-and-publications'
      else
        'only-tags'

  has: (field) ->
    !_.isEmpty(@socialContentCondition[field])

  render: =>
    @$el.html(@template(@))
    @renderTagsConditionEditor()
    @renderTypesConditionEditor()
    @renderOwnershipConditionEditor()
    @renderAncestorsConditionEditor()
    @

  onClickConditionKind: (evt) ->
    @selectedKind = $(evt.currentTarget).val()
    @socialContentCondition = @getCondition()
    @render()

  getCondition: ->
    @socialContentCondition.tags = @tagsConditionEditView.getSelectedTagCodes()
    @socialContentCondition.tags_logic = @tagsConditionEditView.getSelectedLogic()
    @socialContentCondition.subtypes = @typesConditionEditView.getSelectedSubtypes()
    @socialContentCondition.ownership = @ownershipConditionEditView.getSelectedOwnership()
    @socialContentCondition.parent_post_ids = @ancestorsConditionEditView.getParentPostIds()
    @socialContentCondition.parent_tweet_ids = @ancestorsConditionEditView.getParentTweetIds()
    @socialContentCondition.parent_media_ids = @ancestorsConditionEditView.getParentMediaIds()
    @socialContentCondition

  getConditionOfSelectedKind: ->
    @socialContentCondition.tags = if @selectedKind.indexOf('tags') != -1 then @tagsConditionEditView.getSelectedTagCodes() else []
    @socialContentCondition.tags_logic = @tagsConditionEditView.getSelectedLogic()
    @socialContentCondition.subtypes = if @selectedKind.indexOf('types') != -1 then @typesConditionEditView.getSelectedSubtypes() else []
    @socialContentCondition.ownership = @ownershipConditionEditView.getSelectedOwnership()
    @socialContentCondition.parent_post_ids = if @selectedKind.indexOf('publications') != -1 then @ancestorsConditionEditView.getParentPostIds() else []
    @socialContentCondition.parent_tweet_ids = if @selectedKind.indexOf('publications') != -1 then @ancestorsConditionEditView.getParentTweetIds() else []
    @socialContentCondition.parent_media_ids = if @selectedKind.indexOf('publications') != -1 then @ancestorsConditionEditView.getParentMediaIds() else []
    @socialContentCondition

  renderTagsConditionEditor: ->
    @tagsConditionEditView = new Monitoring.Views.MovistarTagsConditionEditView({
      title: 'Tags'
      possibleTags: @possibleTags()
      appliedTags: @appliedTags()
      logic: @socialContentCondition.tags_logic
    })
    @$el.find('#tags-condition-container').html(@tagsConditionEditView.render().el)

  renderTypesConditionEditor: ->
    @typesConditionEditView = new Monitoring.Views.MovistarTypesConditionEditView({
      selectedSubtypes: @socialContentCondition.subtypes
      selectedOwnership: @socialContentCondition.ownership
    })
    @$el.find('#types-condition-container').html(@typesConditionEditView.render().el)

  renderOwnershipConditionEditor: ->
    @ownershipConditionEditView = new Monitoring.Views.MovistarOwnershipConditionEditView({
      selectedOwnership: @socialContentCondition.ownership
    })
    @$el.find('#ownership-condition-container').html(@ownershipConditionEditView.render().el)

  renderAncestorsConditionEditor: ->
    @ancestorsConditionEditView = new Monitoring.Views.MovistarAncestorsConditionEditView({
      parentPostIds: @socialContentCondition.parent_post_ids
      parentTweetIds: @socialContentCondition.parent_tweet_ids
      parentMediaIds: @socialContentCondition.parent_media_ids
    })
    @$el.find('#ancestors-condition-container').html(@ancestorsConditionEditView.render().el)

  possibleTags: ->
    _.map(@availableTags, (tag) =>
      {
        code: tag.code
        description: tag.description
        applied: _.contains(@socialContentCondition.tags, tag.code)
      }
    )

  appliedTags: ->
    _.map(@socialContentCondition.tags, (tag) =>
      {
        code: tag
        description: (_.find(@availableTags, (t) -> t.code == tag) || { description: 'N/A' }).description
        applied: true
      }
    )

  onChangeParentPostIds: (evt) ->
    @onChangeTextProperty('parent_post_ids')

  onChangeParentMediaIds: (evt) ->
    @onChangeTextProperty('parent_media_ids')

  onChangeParentTweetIds: (evt) ->
    @onChangeTextProperty('parent_tweet_ids')

  onChangeTextProperty: (propertyName) ->
    enteredProperty = @$el.find("#condition-#{propertyName.split('_').join('-')}").val().trim()
    asArray = _.map(enteredProperty.split(','), (r) -> r.trim())
    @socialContentCondition[propertyName] = asArray

  onChangeMultiselectProperty: (propertyName) ->
    selectedOptions = @$el.find("#condition-#{propertyName.split('_').join('-')} option:selected")
    enteredProperties = _.map(selectedOptions, (opt) -> opt.value)
    @socialContentCondition[propertyName] = enteredProperties

  allMandatoryFieldsAreFilled: =>
    true
